/* eslint-disable camelcase */
/* eslint-disable import/prefer-default-export */
import { client } from 'lib/evi-api-gateway';

const url = `${process.env.REACT_APP_API_URL}/score`;
const interviewUrl = `${process.env.REACT_APP_API_URL}/admin/interview`;

// interview-panel右侧列表数据
export async function getPanelScoreList({ item_id, time_id, task_id }) {
  return client.post({
    url: `${url}/get_list`,
    form: {
      item_id,
      time_id,
      task_id,
    },
  });
}
// interview-panel右侧评论提交
export async function setPanelScoreComment({
  taskId,
  comment,
  userId,
  phaseId,
  is_score
}) {
  return client.post({
    url: `${url}/set_comment`,
    form: {
      task_id: taskId,
      comment,
      ns_user_id: userId,
      phase_id: phaseId,
      is_score
    },
  });
}
// interview-panel评分储存
export async function savePanelScore({ taskId, scoreData, phaseId }) {
  return client.post({
    url: `${url}/set_score`,
    form: {
      task_id: taskId,
      score_data: scoreData,
      phase_id: phaseId,
    },
  });
}
// interview-panel 获取学生详细信息
export async function getPanelUserInfo({ ns_user_id, phase_id }) {
  return client.post({
    url: `${interviewUrl}/get_interview_user`,
    form: {
      ns_user_id,
      phase_id,
    },
  });
}

// 新增面试学生的评分
export async function AddPanelScore({ ns_user_id, score, phase_id, task_id, is_score }) {
  return client.post({
    url: `${url}/add_score`,
    form: {
      ns_user_id,
      score,
      task_id,
      phase_id,
      is_score
    },
  });
}
